import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { StyledTextField, Wrapper } from './RenameModal.style';
import { CloseIconWrapper, SubmitButtonsWrapper } from 'components/Dialogs/SaveModal/SaveModal.style';
import { ReactComponent as CloseIcon } from 'assets/icons/closeIcon.svg';
import { ModalProps } from 'components/Dialogs/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUserFilenameAction } from 'store/features/pages/actions';
import { selectPageById } from 'store/features/pages/selectors';
import { removeFileExtension } from 'helpers';
import { useFormik } from 'formik';
import * as yup from 'yup';

export const validationFilenameSchema = yup.object({
    filename: yup
        .string()
        .trim()
        .min(1, 'Nazwa pliku musi zawierać mininum jeden znak')
        .max(256, 'Nazwa pliku może zawierać maksymalnie 256 znaków')
        .required('Nazwa pliku jest wymagana')
        .matches(/^[^/\\:*?"<>|]+$/g, 'Nazwa zawiera niedozwolone znaki')
});

const RenameModal = ({ toggleModalOpen, actualPageId }: ModalProps) => {
    const page = useAppSelector(selectPageById(actualPageId));

    const dispatch = useAppDispatch();

    const formik = useFormik({
        initialValues: {
            filename: removeFileExtension(page.userFileName ?? page.fileName.new ?? page.fileName.old)
        },
        validationSchema: validationFilenameSchema,
        onSubmit: values => {
            dispatch(
                setUserFilenameAction({ id: actualPageId, changes: { userFileName: `${values.filename?.trim()}.pdf` } })
            );
            toggleModalOpen(null);
        }
    });

    return (
        <Wrapper>
            <h1>Zmień nazwę pliku</h1>
            <Box component='form' noValidate autoComplete='off' onSubmit={formik.handleSubmit}>
                <StyledTextField
                    id='filename'
                    label='Nazwa pliku'
                    name='filename'
                    variant='outlined'
                    value={formik.values.filename}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.filename && Boolean(formik.errors.filename)}
                    helperText={formik.touched.filename && formik.errors.filename}
                />
                <SubmitButtonsWrapper style={{ marginTop: '18px' }}>
                    <Button variant='text' onClick={() => toggleModalOpen(null)}>
                        Wróć
                    </Button>
                    <Button variant='contained' type='submit'>
                        Zapisz
                    </Button>
                </SubmitButtonsWrapper>
            </Box>
            <CloseIconWrapper>
                <CloseIcon onClick={() => toggleModalOpen(null)} />
            </CloseIconWrapper>
        </Wrapper>
    );
};

export default RenameModal;
